

import { Emit, Component, Prop, Vue } from 'vue-facing-decorator';
import ToggleButton from './ToggleButton.vue';
import {TCModel} from '@iabtcf/core';
import { Vue3SlideUpDown } from "vue3-slide-up-down";
import ChevronIcon from '../icons/ChevronIcon.vue'


// import { Feature } from '@iabtcf/core/GVL/Model/Feature';

// Feature type not exported (WTF???) so we have to define it here

type Feature = {
  id: number;
  name: string;
  description: string;
  descriptionLegal?: string;
  illustrations?: string[];
};


@Component({
  components: {
    ToggleButton,
    Vue3SlideUpDown,
    ChevronIcon
  },
})

export default class SpecialFeatureItem extends Vue {

    consent = false;
    
    expanded = false;
    collapseClass = "collapseButton collapseButtonRotatedUp"

    @Prop( { default:{ name:'none', id:0 } }) feature!: Feature;

    formattedDescriptions :string[] = [];

    mounted() : void {

    // @ts-ignore
      let model = window.__cmpTCModel;
      this.consent = model.specialFeatureOptins.has( this.feature.id );

      let s = this.feature?.descriptionLegal?.replace("Vendors can:", "")

      if ( s ) {
        s = s.replace(/(\r\n|\n|\r)/gm, "")
        s = s.replace("N.B. ", " ")

        this.formattedDescriptions = s.split("* ").filter( ( e : any ) => Boolean((<String>e).length) );
      }

      // console.log(s);

    }


    @Emit('modelChangeEvent')
    changeConsent( value: any, srcEvent: any ) {
      // @ts-ignore
      let model :TCModel = window.__cmpTCModel;
      if ( value.value )
        model.specialFeatureOptins.set( this.feature.id );
      else
        model.specialFeatureOptins.unset( this.feature.id );
        
      this.consent = value.value;

      // TODO: Emit dirty event here to enable button/save
      // this.$emit('modelChangeEvent', true );
    }

    expandCollapseClick() {
      // console.log("expandCollapseClick()")
      if ( ! this.expanded )
        this.collapseClass = 'collapseButton collapseButtonRotatedDown';
      else
        this.collapseClass = 'collapseButton collapseButtonRotatedUp';
      this.expanded = ! this.expanded;
    }

}

